import React from 'react';
import { Select } from '@admitkard/ccl/Select';
import { Text } from '@admitkard/ccl/Text';
import { IconName, Icon } from '@admitkard/ccl/Icon';

interface DropdownProps {
  dropdownCountryValue: string;
  handleCountryChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
  countryToSlugMapping: Record<string, IconName>;
}

export const UniversityCountryDropdown: React.FunctionComponent<DropdownProps> = (props) => {
  const countriesDropDown = Object.keys(props.countryToSlugMapping).map((country, index) => {
    return {
      _id: `${props.countryToSlugMapping[country]}`,
      label: (
        <Text key={index}>
          <Icon size="small" name={props.countryToSlugMapping[country] as IconName} /> {country}
        </Text>
      ),
    };
  });

  return (
    <Select
      size='small'
      onChange={props.handleCountryChange}
      value={props.dropdownCountryValue}
      label="Filter-By"
      items={countriesDropDown.filter((country) => country)}
    ></Select>
  );
};
